<template>
    <div class="relative">
        <span
            class="text-primary font-bold text-sm absolute top-[-30px]"
            v-if="isVideoShared"
            >Shared</span
        >
        <span class="text-primary font-bold absolute top-[-30px]">{{
            video.name
        }}</span>
        <div
            class="bg-white shadow-2xl rounded-lg overflow-hidden relative flex"
            :style="`
flex-direction: ${props.displayMode === 'grid' ? 'column' : 'row'};
`"
        >
            <label
                v-if="bulkSelection.isMode(groupKey)"
                class="
                    absolute
                    top-2
                    left-2
                    z-20
                    bg-white
                    rounded
                    p-1
                    shadow
                    cursor-pointer
                    flex
                    items-center
                "
                @click.stop
            >
                <input
                    type="checkbox"
                    class="w-5 h-5 cursor-pointer accent-primary"
                    :checked="bulkSelection.isSelected(groupKey, video.id)"
                    @change="bulkSelection.toggle(groupKey, video.id)"
                />
            </label>
            <div
                class="
                    rounded-lg
                    relative
                    group
                    flex
                    items-center
                    justify-center
                "
            >
                <div
                    class="
                        relative
                        group
                        text-sm
                        md:text-base
                        w-[320px]
                        flex flex-col
                        overflow-hidden
                    "
                    :style="`width: ${
                        props.displayMode === 'grid' ? '320px' : '120px'
                    }`"
                >
                    <CustomVideoPlayer
                        :data="video"
                        :is-screen-auto="props.displayMode !== 'grid'"
                        :thumbnail="video.thumbnail"
                        :url="video.url"
                        :title="video.title"
                        :start-sec="video.start_sec ?? null"
                        :end-sec="video.end_sec ?? null"
                        custom-fullscreen
                        @fullscreen="handleFullscreen(video)"
                    ></CustomVideoPlayer>
                </div>
            </div>

            <div class="flex items-center gap-4 pt-2 pl-3 pr-1 w-full">
                <div
                    class="
                        flex
                        items-center
                        flex-grow flex-shrink
                        cursor-pointer
                        fit-content
                    "
                    :style="`
gap: ${props.displayMode === 'grid' ? '20px' : '5px'};
align-items: ${props.displayMode === 'grid' ? 'center' : 'flex-start'};
flex-direction: ${props.displayMode === 'grid' ? 'row' : 'column'}`"
                >
                    <div
                        style="flex: 1;
                        max-width: 200px;
                        text-wrap-mode: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        }"
                    >
                        {{ video.title }}
                    </div>

                    <div
                        class="text-xs md:text-sm text-gray-400 pb-2"
                        v-if="props.displayMode === 'list'"
                    >
                        <div>
                            Created at
                            {{ new Date(video.created_at).toLocaleString() }}
                        </div>
                        <div>
                            Size:
                            {{
                                parseFloat(video.size / 1024 / 1024).toFixed(2)
                            }}
                            MB
                        </div>
                    </div>
                </div>

                <div
                    class="flex gap-2 items-center"
                    v-if="displayMode == 'list' && props.videoGroup?.id !== -1"
                >
                    <div
                        class="
                            ml-10
                            my-auto
                            flex
                            border-[1px] border-black
                            rounded-lg
                            overflow-hidden
                        "
                    >
                        <FormationSelector
                            :formations="formations"
                            :value="videoFormation"
                            :team-id="props.video.team_id"
                            @update:modelValue="updateFormation"
                        />
                        <PackageSelector
                            :packages="packages"
                            :value="videoPackage"
                            :team-id="props.video.team_id"
                            @update:modelValue="updatePackage"
                        />
                    </div>
                    <FormationPackageSetting
                        :team-id="props.video.team_id"
                    ></FormationPackageSetting>
                </div>
                <context-menu class="parent">
                    <li>
                        <rename-video-modal
                            :video="video"
                            class="
                                py-2
                                px-3
                                my-1
                                hover:bg-gray-300
                                rounded-lg
                                cursor-pointer
                                flex
                                gap-2
                                items-center
                            "
                        >
                            <img
                                src="/default-images/icons/rename-outline.svg"
                                width="16"
                            />
                            Rename</rename-video-modal
                        >
                    </li>
                    <li>
                        <a
                            v-if="videoGroup?.id !== -1"
                            @click="shareVideo()"
                            class="
                                py-2
                                px-3
                                my-1
                                hover:bg-gray-300
                                rounded-lg
                                cursor-pointer
                                flex
                                gap-2
                                items-center
                            "
                        >
                            <ion-icon
                                class="flex-grow-0 flex-shrink-0"
                                name="share-outline"
                            ></ion-icon>
                            Share</a
                        >
                    </li>
                    <li>
                        <play-selector-modal
                            :video="video"
                            :update-video-tags-api="updateVideoTagsApi"
                            :play-api="playListApi"
                            :playbook-api="playbookApi"
                            :preview-url="previewUrl"
                            :whiteboard-api="whiteboardApi"
                            class="
                                py-2
                                px-3
                                my-1
                                hover:bg-gray-300
                                rounded-lg
                                cursor-pointer
                                flex
                                gap-2
                                items-center
                            "
                        >
                            <ion-icon
                                class="flex-grow-0 flex-shrink-0"
                                name="pricetags-outline"
                            ></ion-icon>
                            Tag Plays</play-selector-modal
                        >
                    </li>
                    <li class="hidden">
                        <video-plays-modal
                            :video="video"
                            :href="href"
                            :show="showPlayModal"
                            class="
                                py-2
                                px-3
                                my-1
                                hover:bg-gray-300
                                rounded-lg
                                cursor-pointer
                            "
                            >Plays</video-plays-modal
                        >
                    </li>

                    <li
                        ref="moveToGroupRef"
                        @click.prevent.stop="showMoveToGroup = true"
                        v-show="videoGroupsWithoutCurrentGroup.length > 0"
                    >
                        <a
                            class="
                                pl-3
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                            "
                        >
                            <div
                                class="
                                    flex-grow flex-shrink
                                    font-slab
                                    py-2
                                    flex
                                    items-center
                                    gap-2
                                "
                            >
                                <ion-icon
                                    class="flex-grow-0 flex-shrink-0"
                                    name="log-in-outline"
                                ></ion-icon>
                                <span>Change Video Group</span>
                            </div>
                        </a>
                    </li>

                    <li>
                        <a
                            :href="`/video/editor?videoId=${video.id}`"
                            class="
                                pl-3
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                            "
                        >
                            <div
                                class="
                                    flex-grow flex-shrink
                                    font-slab
                                    py-2
                                    flex
                                    gap-2
                                    items-center
                                "
                            >
                                <ion-icon
                                    class="flex-grow-0 flex-shrink-0"
                                    name="cut-outline"
                                ></ion-icon>
                                <span>Clip Video</span>
                            </div>
                        </a>
                    </li>

                    <li
                        class="
                            py-2
                            px-3
                            my-1
                            hover:bg-gray-300
                            rounded-lg
                            cursor-pointer
                            flex
                            gap-2
                            items-center
                        "
                        @click="showAiAnalysis = true"
                        v-if="!!teamIdFromUrl"
                    >
                        <ion-icon
                            class="flex-grow-0 flex-shrink-0"
                            name="analytics-outline"
                        ></ion-icon>
                        AI Analysis
                        <span
                            class="
                                text-xs
                                font-semibold
                                bg-primary
                                text-white
                                px-1.5
                                py-0.5
                                rounded-full
                            "
                            >Beta</span
                        >
                    </li>

                    <li
                        v-if="video.is_ai_clip"
                        @click.prevent.stop="createPlayFromClip"
                        class="
                            py-2
                            px-3
                            my-1
                            hover:bg-gray-300
                            rounded-lg
                            cursor-pointer
                            flex
                            gap-2
                            items-center
                        "
                    >
                        <ion-icon
                            class="flex-grow-0 flex-shrink-0"
                            :name="
                                createFromClipState === 'done'
                                    ? 'checkmark-outline'
                                    : createFromClipState === 'error'
                                    ? 'close-outline'
                                    : 'add-circle-outline'
                            "
                        ></ion-icon>
                        <span v-if="createFromClipState === 'loading'"
                            >Creating…</span
                        >
                        <span v-else-if="createFromClipState === 'done'"
                            >Play Created!</span
                        >
                        <span v-else-if="createFromClipState === 'error'"
                            >Failed — try again</span
                        >
                        <span v-else>Create Play from Clip</span>
                    </li>

                    <li @click="$refs.deleteForm.submit()">
                        <form
                            action="/video/delete"
                            method="post"
                            ref="deleteForm"
                        >
                            <input
                                type="hidden"
                                name="_token"
                                :value="$root.csrfToken"
                            />
                            <input
                                type="hidden"
                                name="id"
                                :value="props.video.id"
                            />
                            <div
                                class="
                                    py-2
                                    pl-3
                                    pr-8
                                    flex flex-row
                                    items-center
                                    text-left
                                    gap-2
                                    cursor-pointer
                                    hover:bg-gray-300
                                    rounded-lg
                                "
                            >
                                <button
                                    type="submit"
                                    class="
                                        flex-grow-1 flex-shrink-0
                                        font-slab
                                        gap-2
                                        flex
                                        items-center
                                        text-red-500
                                    "
                                >
                                    <ion-icon
                                        class="flex-grow-0 flex-shrink-0"
                                        name="trash-outline"
                                    ></ion-icon>
                                    Delete
                                </button>
                            </div>
                        </form>
                    </li>
                </context-menu>
            </div>

            <div
                class="text-xs md:text-sm text-gray-400 px-3 pb-2"
                v-if="props.displayMode === 'grid'"
            >
                <div>
                    Created at
                    {{ new Date(video.created_at).toLocaleString() }}
                </div>
                <div>
                    Size:
                    {{ parseFloat(video.size / 1024 / 1024).toFixed(1) }} MB
                </div>
            </div>
        </div>
        <ModalCustom
            :is-open="share.isOpen"
            @close="share.isOpen = false"
            title="Share Play"
        >
            <div
                class="flex items-center justify-center"
                v-if="share.isGenerating"
            >
                <simple-loading-circle />
            </div>
            <div class="flex items-center bg-gray-200 rounded p-2 gap-2" v-else>
                <input
                    type="text"
                    class="w-full w-max-[240px] bg-transparent outline-none"
                    :value="share.link"
                    readonly
                    @click="$event.target.select()"
                />
                <button
                    class="bg-gray-300 rounded p-2"
                    @click="copyShareLink"
                    title="Copy to clipboard"
                >
                    <ion-icon name="copy-outline"></ion-icon>
                </button>
            </div>
            <div class="mt-6">
                <input
                    type="checkbox"
                    :readonly="share.isLoading"
                    v-model="share.isPublic"
                    id="share_is_public"
                    @change="updateShareVisibility"
                />
                <label for="share_is_public">
                    <span class="ml-2">Public</span>
                </label>
                <div class="text-sm text-gray-500">
                    Public plays can be viewed by anyone with the link.
                </div>
            </div>
            <div class="mt-6" v-if="!share.isPublic">
                <h4 class="uppercase text-sm font-semibold">Allowed User</h4>
                <div
                    class="my-4 flex gap-2 flex-wrap max-w-lg"
                    v-if="share.members.length > 0"
                >
                    <div
                        v-for="(member, index) in share.members"
                        :key="member.id"
                        class="
                            text-sm
                            p-2
                            rounded
                            inline-flex
                            bg-gray-100
                            gap-2
                            items-center
                        "
                    >
                        <img
                            :src="member.user?.avatar"
                            :alt="member.user?.name"
                            v-if="member.user?.avatar"
                            class="w-8 h-8 rounded-full aspect-square"
                        />
                        {{ member.user?.name ?? member.email }}
                        <button
                            type="button"
                            class="
                                bg-transparent
                                text-gray-500
                                flex
                                items-center
                                hover:text-gray-700 hover:bg-gray-300
                                p-1
                                rounded-lg
                            "
                            @click="removeShareMember(index)"
                        >
                            <ion-icon name="close-outline"></ion-icon>
                        </button>
                    </div>
                </div>
                <div class="flex items-center gap-2 my-4">
                    <MemberMultiselectInput
                        :current-users="share.members"
                        :selected-users="share.selectedUsers"
                        @select="addShareMember"
                        @remove="removeShareMember"
                    ></MemberMultiselectInput>
                </div>

                <h4 class="uppercase text-sm font-semibold">External User</h4>
                <div class="flex items-center gap-2 my-4">
                    <NonMemberMultiselectInput
                        :current-users="share.members"
                        :selected-users="share.selectedEmails"
                        @select="addShareExternal"
                        @remove="removeShareExternal"
                    ></NonMemberMultiselectInput>
                </div>

                <div class="flex">
                    <button
                        @click="saveShareMember()"
                        class="bg-primary text-white rounded-lg p-1 px-4 mt-4"
                    >
                        Share
                    </button>
                </div>
            </div>
            <div
                v-if="!share.isPublic && share.members.length === 0"
                class="bg-blue-100 text-gray-700 p-2 my-4 text-xs rounded"
            >
                This play can be only viewed by you.
            </div>
        </ModalCustom>
    </div>

    <Teleport to="body" v-show="showMoveToGroup">
        <div
            class="fixed w-full h-full z-30 top-0 left-0"
            v-if="showMoveToGroup"
            @click.self="showMoveToGroup = false"
        ></div>
        <div
            ref="moveToGroupPopup"
            class="absolute bg-gray-200 shadow-xl rounded-lg z-40 text-black"
            v-show="showMoveToGroup"
        >
            <div class="p-2">
                <div class="flex flex-col gap-2">
                    <form
                        v-for="videoGroup in videoGroupsWithoutCurrentGroup"
                        method="post"
                        action="/video/move-group"
                        :key="videoGroup.id"
                    >
                        <input
                            type="hidden"
                            name="video_id"
                            :value="video.id"
                        />
                        <input
                            type="hidden"
                            name="video_group_id"
                            :value="videoGroup.id"
                        />
                        <input
                            type="hidden"
                            name="_token"
                            :value="$root.csrfToken"
                        />
                        <button
                            type="submit"
                            class="
                                bg-gray-100
                                py-2
                                px-3
                                rounded-md
                                hover:bg-primary hover:text-white
                                cursor-pointer
                            "
                        >
                            {{ videoGroup.name }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </Teleport>
    <!-- AI Analysis inline modal -->
    <Teleport to="body">
        <div
            v-if="showAiAnalysis"
            style="
                position: fixed;
                inset: 0;
                z-index: 9999;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(0, 0, 0, 0.5);
            "
            @click.self="showAiAnalysis = false"
        >
            <div
                style="
                    background: #fff;
                    border-radius: 12px;
                    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
                    width: 100%;
                    max-width: 440px;
                    padding: 24px;
                    position: relative;
                "
            >
                <button
                    @click="showAiAnalysis = false"
                    style="
                        position: absolute;
                        top: 14px;
                        right: 14px;
                        background: none;
                        border: none;
                        cursor: pointer;
                        font-size: 1.25rem;
                        color: #9ca3af;
                        line-height: 1;
                    "
                    title="Close"
                >
                    &times;
                </button>
                <h2
                    style="
                        font-size: 1.1rem;
                        font-weight: 700;
                        margin-bottom: 4px;
                    "
                >
                    AI Analysis
                </h2>
                <p
                    style="
                        font-size: 0.875rem;
                        color: #6b7280;
                        margin-bottom: 16px;
                    "
                >
                    Analyze
                    <strong style="color: #374151">{{ video.title }}</strong> to
                    automatically detect plays, create clips, and build a
                    playbook.
                </p>

                <!-- confirm -->
                <div v-if="aiPhase === 'idle'">
                    <ul
                        style="
                            list-style: disc;
                            padding-left: 20px;
                            color: #4b5563;
                            font-size: 0.875rem;
                            margin-bottom: 24px;
                        "
                    >
                        <li>Detect plays in the video using AI</li>
                        <li>
                            Add each clip to
                            <strong>{{
                                videoGroup?.name ?? "this Video Group"
                            }}</strong>
                        </li>
                        <li>
                            Create a new playbook named
                            <strong>{{
                                videoGroup?.name ?? "AI Analysis"
                            }}</strong>
                        </li>
                        <li>Create a whiteboard play for each clip</li>
                    </ul>
                    <p
                        style="
                            font-size: 0.8rem;
                            color: #6b7280;
                            margin-bottom: 12px;
                        "
                    >
                        You'll receive a notification when the analysis is
                        complete.
                    </p>
                    <label
                        style="
                            display: flex;
                            align-items: center;
                            gap: 8px;
                            font-size: 0.85rem;
                            color: #374151;
                            margin-bottom: 16px;
                            cursor: pointer;
                        "
                    >
                        <input
                            type="checkbox"
                            v-model="cutClips"
                            style="width: 15px; height: 15px; cursor: pointer"
                        />
                        Cut individual clip files
                        <span style="color: #6b7280; font-size: 0.78rem"
                            >(downloads full video + runs FFmpeg)</span
                        >
                    </label>
                    <div
                        style="
                            display: flex;
                            gap: 12px;
                            justify-content: flex-end;
                        "
                    >
                        <button
                            @click="showAiAnalysis = false"
                            style="
                                padding: 8px 16px;
                                font-size: 0.875rem;
                                border: 1px solid #d1d5db;
                                border-radius: 8px;
                                cursor: pointer;
                            "
                        >
                            Cancel
                        </button>
                        <button
                            @click="aiStart"
                            :disabled="aiSubmitting"
                            style="
                                padding: 8px 16px;
                                font-size: 0.875rem;
                                border-radius: 8px;
                                background: #4f46e5;
                                color: #fff;
                                cursor: pointer;
                                border: none;
                                opacity: 1;
                            "
                            :style="
                                aiSubmitting ? 'opacity:.6;cursor:default' : ''
                            "
                        >
                            {{
                                aiSubmitting ? "Submitting…" : "Run AI Analysis"
                            }}
                        </button>
                    </div>
                </div>

                <!-- error (only if the initial POST itself fails) -->
                <div v-else-if="aiPhase === 'error'">
                    <p
                        style="
                            color: #ef4444;
                            font-weight: 600;
                            margin-bottom: 12px;
                        "
                    >
                        &#9888; Could not start analysis
                    </p>
                    <p
                        style="
                            font-size: 0.875rem;
                            color: #4b5563;
                            margin-bottom: 16px;
                        "
                    >
                        {{ aiError }}
                    </p>
                    <div
                        style="
                            display: flex;
                            gap: 12px;
                            justify-content: flex-end;
                        "
                    >
                        <button
                            @click="showAiAnalysis = false"
                            style="
                                padding: 8px 16px;
                                font-size: 0.875rem;
                                border: 1px solid #d1d5db;
                                border-radius: 8px;
                                cursor: pointer;
                            "
                        >
                            Close
                        </button>
                        <button
                            @click="aiPhase = 'idle'"
                            style="
                                padding: 8px 16px;
                                font-size: 0.875rem;
                                border-radius: 8px;
                                background: #4f46e5;
                                color: #fff;
                                cursor: pointer;
                                border: none;
                            "
                        >
                            Retry
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
import emitter from "tiny-emitter/instance";
import ModalCustom from "./ModalCustom";
import TagForm from "./TagForm";
import { createPopper } from "@popperjs/core";
import Modal from "./Modal";
import VideoPlayer from "./VideoPlayer";
import AppInput from "./AppInput";
import AppButton from "./AppButton";
import { ref, onMounted, watch, nextTick, reactive, computed } from "vue";
import draggable from "vuedraggable";
import bulkSelection from "../stores/bulkSelection";

const showAiAnalysis = ref(false);
const aiPhase = ref("idle");
const aiSubmitting = ref(false);
const aiError = ref("");
const cutClips = ref(false);

const createFromClipState = ref("idle"); // idle | loading | done | error

async function createPlayFromClip() {
    createFromClipState.value = "loading";
    try {
        await axios.post("/api/v1/plays/create-from-clip", {
            video_id: props.video.id,
        });
        createFromClipState.value = "done";
        setTimeout(() => {
            createFromClipState.value = "idle";
        }, 2500);
    } catch (err) {
        createFromClipState.value = "error";
        setTimeout(() => {
            createFromClipState.value = "idle";
        }, 2500);
    }
}

watch(showAiAnalysis, (val) => {
    if (val) {
        aiPhase.value = "idle";
        aiError.value = "";
        aiSubmitting.value = false;
        cutClips.value = false;
    }
});

async function aiStart() {
    aiSubmitting.value = true;
    try {
        await axios.post(`/api/v1/videos/${props.video.id}/ai-analysis`, {
            cut_clips: cutClips.value,
        });
        showAiAnalysis.value = false;
    } catch (err) {
        aiPhase.value = "error";
        aiError.value =
            err?.response?.data?.message ?? "An unexpected error occurred.";
    } finally {
        aiSubmitting.value = false;
    }
}

const props = defineProps({
    teams: {
        default: [],
        type: Array,
        required: false,
    },
    video: {
        type: Object,
        required: true,
    },
    videoGroup: {
        type: Object,
        required: true,
    },
    videoGroups: {
        type: Array,
        required: true,
    },
    updateVideoTagsApi: {
        type: String,
        required: true,
    },
    playbookApi: {
        type: String,
        required: true,
    },
    playListApi: {
        type: String,
        required: true,
    },
    previewUrl: {
        type: String,
        required: true,
    },
    href: {
        type: String,
        required: true,
    },
    isShared: {
        type: Boolean,
    },
    showPlayModal: {
        type: Boolean,
        required: false,
        default: false,
    },
    displayMode: {
        type: String,
        default: "grid",
    },
    formations: {
        type: Array,
    },
    packages: {
        type: Array,
    },
});

const state = reactive({
    formationId: null,
    packageId: null,
});

// Bulk-selection key, scoped to this video's group.
const groupKey = computed(() => `video-${props.videoGroup?.id}`);

const share = reactive({
    link: null,
    isGenerating: false,
    isOpen: false,
    isPublic: false,
    members: [],
    memberInput: "",
    isLoading: false,
    token: null,
    isLoaded: false,
    selectedUsers: [],
    selectedEmails: [],
});

const videoFormation = computed(() => {
    if (state.formationId) {
        return state.formationId;
    }
    return props.video.formation_id;
});

const videoPackage = computed(() => {
    if (state.packageId) {
        return state.packageId;
    }
    return props.video.package_id;
});

const teamIdFromUrl = new URLSearchParams(window.location.search).get("teamId");
const popperInstance = ref(null);

const isVideoShared = computed(() => {
    if (share.isLoaded) {
        return share.members.length > 0;
    }

    return props.isShared;
});

function shareVideo() {
    share.isOpen = true;
    share.isGenerating = true;
    axios
        .post("/shared-link/create", {
            resource_type: "videos",
            resource_id: props.video.id,
        })
        .then((response) => {
            share.isGenerating = false;
            share.link = response.data.link;
            share.members = response.data.data.members.map((member) => member);
            share.token = response.data.data.token;
            share.isPublic = response.data.data.visibility === "public";
            share.isLoaded = true;
        })
        .catch((error) => {
            share.isGenerating = false;
            console.log(error);
        });
}

async function updateShareVisibility() {
    try {
        share.isLoading = true;
        await axios.post(`/shared-link/update/${share.token}`, {
            visibility: share.isPublic ? "public" : "private",
        });
    } catch (e) {
        console.log(e);
    }
    share.isLoading = false;
}

function addShareMember(user) {
    share.selectedUsers.push(user);
}

async function removeShareMember(index) {
    const removed = share.members.splice(index, 1);
    await axios.post(`/shared-link/member/${share.token}/remove`, {
        id: removed[0].id,
    });
}

function addShareExternal(user) {
    share.selectedEmails.push(user);
}

function removeShareExternal(user) {
    share.selectedEmails = share.selectedEmails.filter(
        (u) => u.email !== user.email
    );
}

async function saveShareMember() {
    try {
        share.isLoading = true;
        const res = await axios.post(
            `/shared-link/member/${share.token}/batch-add`,
            {
                users: share.selectedUsers,
                emails: share.selectedEmails,
            }
        );
        share.members = [...share.members, ...res.data];
    } catch (e) {
        console.log(e);
    }
    share.selectedUsers = [];
    share.selectedEmails = [];
    share.isLoading = false;
}

const showMoveToGroup = ref(false);
const moveToGroupRef = ref(null);
const moveToGroupPopup = ref(null);

const videoGroupsWithoutCurrentGroup = computed(() => {
    if (!props.videoGroups) {
        return [];
    }
    const groupId = props.video.video_group_id ?? -1;
    return props.videoGroups.filter((vg) => vg.id != groupId && vg.id != -1);
});

watch(showMoveToGroup, (newValue) => {
    if (newValue) {
        nextTick(() => {
            popperInstance.value = createPopper(
                moveToGroupRef.value,
                moveToGroupPopup.value,
                {
                    placement: "right",
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [0, 8],
                            },
                        },
                    ],
                }
            );

            popperInstance.value.forceUpdate();
        });
    } else {
        popperInstance.value.destroy();
    }
});

async function updateFormation(formation_id) {
    state.formationId = formation_id;
    axios.post(`/video/${props.video.id}/update-formation`, {
        formation_id,
    });
}

async function updatePackage(package_id) {
    state.packageId = package_id;
    axios.post(`/video/${props.video.id}/update-package`, {
        package_id,
    });
}

function handleFullscreen(video) {
    emitter.emit("open-playlist", video);
}
</script>

<style scoped>
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
